// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { RevenueCommissionValueItem } from "./RevenueCommissionValueItem.js";
export let RevenueCommissionValueItemForPerFill = function ()
{
    this.minTradedValue = 0.0;
}
RevenueCommissionValueItemForPerFill.prototype = Object.create(RevenueCommissionValueItem.prototype)

Object.defineProperty(RevenueCommissionValueItemForPerFill.prototype, "MinTradedValue",
    {
        get: function () { return this.minTradedValue; },
        set: function (value) { this.minTradedValue = value; }
    });

RevenueCommissionValueItemForPerFill.prototype.GetFixedCommissionValue = function (commission, ignoreMinMaxCorrection = false, markup = 1.0)
{
    //For symbol info panel return value
    if (commission == 0)
        return this.Value;
    return commission < this.minTradedValue * markup ? 0 : this.Value * markup;
}
